module.exports = __webpack_public_path__ + "img/imagen-consultar.bef2f29f.png";